import { Card } from '@mui/material';
import MemberReviewForm from 'components/membershipManagement/MemberReviewForm';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const MembersCard: React.FC = () => {
  const members = useSelector((state: RootState) => state.platformAdmin?.members) || [];

  console.log('Members:', members); // Debugging line

  return (
    <Card>
      <MemberReviewForm />
    </Card>
  );
};

export default MembersCard;
